import React from 'react'
import PropTypes from 'prop-types'

import Star from '../../../assets/star.svg'

import './PopularItemImage.css'

export const PopularItemImage = ({ imageUrl }) => {
  if (!imageUrl) {
    return (
      <div styleName='star'>
        <Star />
      </div>
    )
  }
  return (
    <div
      style={{ backgroundImage: `url(${imageUrl})` }}
      styleName='image'
    />
  )
}

PopularItemImage.propTypes = {
  imageUrl: PropTypes.string
}
